import React from 'react';

import { ISideBySideHeroFields } from '../../../types/contentful';

import RichText from '../RichText';
import { renderUnoptimizedImage } from '../../utils/contentful';

export function SideBySideHero({
  copy,
  headingText,
  image,
  desktopImage
}: ISideBySideHeroFields) {
  return (
    <section
      className="block-container mt-3 [&>*]:max-w-[1472px] [&>*]:px-3 [&>*]:tablet:px-12"
      data-blockid="hero-5050"
      data-testid="hero-5050"
      data-e2e="hero"
    >
      <div className="-m-3 box-border flex w-full flex-1 flex-col-reverse flex-wrap items-center justify-center tablet:flex-row desktop:-m-4 [&>*]:p-3 [&>*]:desktop:p-4">
        <div className="column w-full pb-1 tablet:mr-12 tablet:w-1/3">
          <div className="flex flex-col text-center tablet:text-left">
            <h1
              className="typography-display-2 mb-4 font-normal"
              data-blockid="hero-5050-heading"
            >
              {headingText}
            </h1>
            {copy && (
              <div
                className="mb-6 w-full [&>div]:!w-full tablet:[&>div]:!w-auto [&_div]:items-center tablet:[&_div]:items-start [&_form]:!w-full [&_form]:items-center tablet:[&_form]:!w-auto tablet:[&_form]:items-start"
                data-blockid="hero-5050-copy"
              >
                <RichText data={copy} />
              </div>
            )}
          </div>
        </div>
        <div
          className="column !hidden w-1/2 tablet:!block desktop:w-1/2"
          data-testid="hero-desktop-image"
        >
          {renderUnoptimizedImage(desktopImage!, 'h-full w-full object-cover')}
        </div>
        <div
          className="column block w-full tablet:!hidden"
          data-testid="hero-mobile-image"
        >
          {renderUnoptimizedImage(image, 'h-full w-full object-cover')}
        </div>
      </div>
    </section>
  );
}
